export default __webpack_public_path__ + "static/24-c0fd4a712aed1563fb64e015523129d4.png";